// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBzB6TmAuhd2MOinmoTraVdAez4GKojRZY",
    authDomain: "hemispheresneuro.firebaseapp.com",
    databaseURL: "https://hemispheresneuro.firebaseio.com",
    projectId: "hemispheresneuro",
    storageBucket: "hemispheresneuro.appspot.com",
    messagingSenderId: "1065402992892",
    appId: "1:1065402992892:web:a4164360ce404f772b2f79"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const database = getDatabase(app);

const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";
const emulatorHost = process.env.REACT_APP_FIREBASE_EMULATOR_HOST
    || (typeof window !== "undefined" ? window.location.hostname : "")
    || "localhost";

if (useEmulators) {
    const authPort = Number(process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_PORT || 9099);
    const firestorePort = Number(process.env.REACT_APP_FIREBASE_FIRESTORE_EMULATOR_PORT || 8080);
    const storagePort = Number(process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_PORT || 9199);
    const functionsPort = Number(process.env.REACT_APP_FIREBASE_FUNCTIONS_EMULATOR_PORT || 5001);

    // Avoid crashing on hot reload if emulator is already connected.
    try {
        if (!auth.emulatorConfig) {
            connectAuthEmulator(auth, `http://${emulatorHost}:${authPort}`, { disableWarnings: true });
        }
    } catch (e) {
        console.warn("Auth emulator connection warning:", e);
    }

    try {
        connectFirestoreEmulator(firestore, emulatorHost, firestorePort);
    } catch (e) {
        console.warn("Firestore emulator connection warning:", e);
    }

    try {
        connectStorageEmulator(storage, emulatorHost, storagePort);
    } catch (e) {
        console.warn("Storage emulator connection warning:", e);
    }

    try {
        connectFunctionsEmulator(functions, emulatorHost, functionsPort);
    } catch (e) {
        console.warn("Functions emulator connection warning:", e);
    }

    if (process.env.REACT_APP_FIREBASE_DATABASE_EMULATOR_PORT) {
        const databasePort = Number(process.env.REACT_APP_FIREBASE_DATABASE_EMULATOR_PORT);
        try {
            connectDatabaseEmulator(database, emulatorHost, databasePort);
        } catch (e) {
            console.warn("Database emulator connection warning:", e);
        }
    }

    console.log(`Firebase emulators enabled at ${emulatorHost}`);
}

function isSignedIn() {
    return auth.currentUser !== null;
}

function getCurrentUser() {
    return auth.currentUser;
}

export { app, auth, getCurrentUser, isSignedIn };
